import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Field, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class AudioEffectCompositeBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new AudioEffectCompositeBox({
            uuid,
            graph,
            name: "AudioEffectCompositeBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "AudioEffectCompositeBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "device", deviceType: "audio-effect" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitAudioEffectCompositeBox, this);
    }
    get tags() {
        return AudioEffectCompositeBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get entries() {
        return this.getField(10);
    }
    get input() {
        return this.getField(11);
    }
    get dry() {
        return this.getField(12);
    }
    get wet() {
        return this.getField(13);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.AudioEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: Field.hook({
                parent: this,
                fieldKey: 10,
                fieldName: "entries",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.AudioEffectCompositeCell],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            11: Field.hook({
                parent: this,
                fieldKey: 11,
                fieldName: "input",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.SideChain],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "dry",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "decibel", "dB", -Infinity),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "wet",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "decibel", "dB", 0),
        };
    }
}
